import { getCookie } from './cookies'
import {
  currentDeviceIdleAction,
  currentDeviceProfileId,
  readDeviceProfiles,
  touchDeviceLastUse
} from './device-profiles'

export const STUDENT_PICKER_URL = '/app-v2/trocar-perfil'

export const FAMILY_PICKER_URL = '/app-v2/familia/perfis'

export const PROFILE_SAVED_NOTICE_URL = '/app-v2/perfil-salvo'

const NO_PICK_PATHS = ['/logout', '/login', '/auth']

const TOUCH_THROTTLE_MS = 60 * 1000

const CHECK_INTERVAL_MS = 60 * 1000

const ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll']

const isPickExempt = (pathname: string): boolean =>
  NO_PICK_PATHS.some(
    path => pathname === path || pathname.startsWith(`${path}/`)
  )

const pickerUrl = (): string => {
  const currentId = currentDeviceProfileId()
  const current = readDeviceProfiles().find(profile => profile.id === currentId)
  return current?.kind === 'adult' ? FAMILY_PICKER_URL : STUDENT_PICKER_URL
}

export const applyDeviceIdleAction = (): boolean => {
  const action = currentDeviceIdleAction()
  if (action === 'logout' && !isPickExempt(window.location.pathname)) {
    document.documentElement.style.visibility = 'hidden'
    window.location.replace('/logout')
    return true
  }
  if (action === 'pick' && !isPickExempt(window.location.pathname)) {
    document.documentElement.style.visibility = 'hidden'
    window.location.replace(pickerUrl())
    return true
  }
  return false
}

export const startDeviceIdleWatch = (): (() => void) => {
  let lastTouch = 0

  const touch = (force = false) => {
    if (!getCookie('access_token')) return
    const now = Date.now()
    if (force || now - lastTouch >= TOUCH_THROTTLE_MS) {
      lastTouch = now
      touchDeviceLastUse(now)
    }
  }
  const onActivity = () => touch()
  const onVisibility = () => {
    if (document.visibilityState === 'hidden') {
      touch(true)
      return
    }
    if (!applyDeviceIdleAction()) touch(true)
  }
  const interval = window.setInterval(() => {
    if (document.visibilityState === 'visible') applyDeviceIdleAction()
  }, CHECK_INTERVAL_MS)

  touch(true)
  ACTIVITY_EVENTS.forEach(event =>
    window.addEventListener(event, onActivity, { passive: true })
  )
  document.addEventListener('visibilitychange', onVisibility)

  return () => {
    window.clearInterval(interval)
    ACTIVITY_EVENTS.forEach(event =>
      window.removeEventListener(event, onActivity)
    )
    document.removeEventListener('visibilitychange', onVisibility)
  }
}
